import styled from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

export const Text = styled.div`
	font-size: ${rem(14)};
	line-height: ${rem(26)};
	text-align: center;
	color: ${({ theme }) => theme.color.grayTen};
	margin-bottom: ${rem(30)};
	@media (${device.mobileL}) {
		margin-bottom: ${rem(13)};
	}
`
